/** A line that CommonMark treats as a setext underline (or a thematic break). */
const SETEXT_UNDERLINE_RE = /^[ \t]*(?:={3,}|-{3,})[ \t]*$/

/**
 * Emails and pastes use `---` as a separator. CommonMark treats
 * `Steve:\n---` as a setext heading, so the prompt bubble renders an h2.
 * Insert a blank line so the dashes become a thematic break instead.
 */
function breakSetextUnderlines(src: string): string {
  const lines = src.split('\n')
  const out: string[] = []
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    const prev = out.length > 0 ? out[out.length - 1] : ''
    if (
      SETEXT_UNDERLINE_RE.test(line) &&
      prev.trim() !== '' &&
      !SETEXT_UNDERLINE_RE.test(prev)
    ) {
      out.push('')
    }
    out.push(line)
  }
  return out.join('\n')
}

/**
 * CommonMark treats a single newline as a space. User pastes expect those
 * lines to stay visible in the sent bubble (edit already shows raw text).
 * Convert soft breaks to GFM hard breaks (`  \n`) outside fenced code.
 * Also neutralize setext `---` / `===` underlines from email separators.
 */
export function preserveUserPromptLineBreaks(src: string): string {
  const normalized = String(src ?? '')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
  if (!normalized.includes('\n')) return normalized

  const parts = normalized.split(/(```[\s\S]*?```)/g)
  return parts
    .map((part, i) => {
      if (i % 2 === 1) return part
      return breakSetextUnderlines(part).replace(/([^\n])\n(?!\n)/g, '$1  \n')
    })
    .join('')
}
